<template>
<div class="chyron size-small" :class="{atlas}">
  <div class="row">
    <div class="col weather ticker">
      <text-marquee :text="timeTicker" v-if="timeTicker && show"></text-marquee>
    </div>
    <div class="col social-links">
      <div class="row">
        <a class="col social-link social-link-a" target="_blank" href="https://instagram.com/explore/tags/52Artists52Actions">
          #52Artists52Actions
        </a>
      </div>
      <div class="row">
        <a class="col social-link social-link-b" target="_blank" :href="`https://instagram.com/${$store.state.site.data['instagram']}`">
          @{{$store.state.site.data['instagram']}}
        </a>
      </div>
    </div>
  </div>

  <div class="row">
    <router-link to="/" class="col logo logo-a">52 Artists</router-link>
    <router-link to="/" class="col logo logo-b">52 Actions</router-link>
    <div class="col languages ticker">
      <text-marquee v-if="languageTicker && show" :text="languageTicker" :speed="languageTickerSpeed"></text-marquee>
    </div>
  </div>

  <div class="row" v-if="!atlas">
    <div class="col time">
      <div class="content">{{clock}}</div>
      <span class="logo logo-a spacer">52 Artists</span>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import { DateTime, Duration } from 'luxon'
import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'
import linkify from 'linkifyjs/html'

const spacer = (n = 6) => Array.from(new Array(n)).map(_ => '&nbsp;').join('')

export default Vue.component('Chyron', {
  props: ['atlas', 'show'],
  data: () => ({
    dt: DateTime.local(),
    timeTicker: null,
    offsets: {},
    languageTickerSpeed: 1
  }),
  created() {
    this.tick()
    this.createTimeTicker()
    setInterval(this.tick, 1000)
    setInterval(this.createTimeTicker, 1000 * 60)

    this.languageTickerSpeed = window.matchMedia('(max-width: 560px)').matches ? 1 : 2
  },
  methods: {
    tick() {
      this.dt = DateTime.local()
    },
    createTimeTicker() {
      this.timeTicker = this.cities.map(({city,country,id,timezone,weather}) => {
        let text = _.filter([city, country]).join(', ')
        const { offset, shortName } = this.offsets[timezone]
        let ts = DateTime.utc().plus(Duration.fromObject({ minutes: offset })).toFormat('ccc T')

        if(offset > 0) {
          ts += ` GMT+${(offset / 60).toString().padStart(2, '0')}`
        } else {
          ts += ` GMT${(offset / 60).toString().padStart(2, '0')}`
        }

        const temp = _.get(weather, 'main.temp')
        const icon = _.get(weather, 'weather.0.icon')
        if(temp && icon) {
          const iconHtml = `<img src="/static/images/weather/${icon}.svg" />`
          return `${text} ${ts} ${iconHtml} ${temp}&deg;C`
        } else {
          return `${text} ${ts}`
        }
      }).join(spacer(3)) + spacer(3)
    },
  },
  watch: {
    cities(cities) {
      if(cities) {
        this.offsets = _.fromPairs(
          _.map(
            _.uniq(_.map(cities, 'timezone')),
            timezone => {
              const { offset, offsetNameShort } = this.dt.setZone(timezone)
              return [timezone, { offset, shortName: offsetNameShort }]
            })
        )

        this.createTimeTicker()
      }
    }
  },
  computed: {
    clock() {
      return this.dt.toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET)
    },
    cities() {
      return this.$store.state.site.cities
    },

    languageTicker() {
      const t = _.map(_.get(this.$store.state.site, 'data.translations'), 'text')
      const ticker = t.join(spacer(3)) + spacer(3)

      return ticker
    }
  }
})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.chyron {
  width: 100%;
  &:not(.atlas) {
    position: absolute;
    bottom: 0; left: 0;
    padding: $gutter;
    @media (max-width: $break-small) {
      padding: 0;
    }
  }
}
.row {
  position: relative;
  display: flex;
  @media(max-width: $break-small) {
    &:nth-of-type(1) {
      display: block;
    }
  }
}
.ticker {
  height: 4rem;
}
.weather {
  background: $color-white;
  font-family: $font-mono;
  font-weight: normal;
  text-transform: uppercase;
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  .atlas & {
    background: $color-blue;
    color: $color-white;
    /deep/ img {
      filter: invert(1);
    }
  }
}
.social-links {
  text-transform: uppercase;
  @media (max-width: $break-small) {
    display: flex;
    flex-direction: row-reverse;
    .row {
      flex: 1;
    }
  }
  .col {
    text-align: center;
    height: 2rem;
    line-height: 1.5;
    display: block;
  }
}
.social-link {
  padding: 0.1rem 0;
  &-a {
    background: $color-red;
    &:hover {
      color: $color-black;
    }
  }
  &-b {
    background: $color-gray;
    &:hover {
      color: $color-black;
    }
  }
}
.logo, .social-links .col {
  width: 19rem;
  @media (max-width: $break-small) {
    width: 100%;
  }
}
.logo {
  font-size: $size-medium;
  text-transform: uppercase;
  text-align: center;
  height: 4rem;
  line-height: 1.5;
  &.spacer {
    visibility: hidden;
  }
  &-a {
    background: $color-black;
    color: $color-red;
  }
  &-b {
    background: $color-gray;
    &:hover {
      color: $color-black;
    }
  }
}
.languages {
  background: $color-black;
  color: $color-white;
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: $font-mono;
  font-weight: normal;
  text-transform: uppercase;
  @media (max-width: $break-small) {
    position: absolute;
    left: 50%;
    bottom: 0; right: 0;
    transform: translateY(100%);
  }
}
.time {
  position: relative;
  @media (max-width: $break-small) {
    width: 50%;
    height: 4rem;
    .content {
      width: 100%!important;
    }
  }
  .content {
    position: absolute;
    top: 0; left: 0;
    bottom: 0; right: 0;
    background: $color-blue;
    color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: $font-mono;
    font-weight: normal;
    width: 19rem;
  }
}
</style>

<style>
.chyron .ticker img {
  height: 1em;
  transform: scale(1.25) translateY(0.05rem);
  margin: 0 0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/chyron.vue